import { Booking, Event, Inquiry, Payment, Revision } from "sweet-global";
export const RESET_BOOKING = "booking/RESET_BOOKINGS";
export const GET_BOOKINGS_INIT = "booking/GET_BOOKINGS_INIT";
export const GET_BOOKINGS_SUCCESS = "booking/GET_BOOKINGS_SUCCESS";
export const GET_BOOKING_REVISIONS_SUCCESS =
  "booking/GET_BOOKING_REVISIONS_SUCCESS";
export const GET_BOOKINGS_FAILURE = "booking/GET_BOOKINGS_FAILURE";
export const LOAD_EDITABLE_BOOKING = "booking/LOAD_EDITABLE_BOOKING";
export const EDIT_BOOKING = "booking/EDIT_BOOKING";
export const DELETE_BOOKING = "booking/DELETE_BOOKING";
export const DELETE_REVISION = "booking/DELETE_REVISION";
export const CREATE_BOOKING_INIT = "booking/CREATE_BOOKING_INIT";
export const CREATE_BOOKING_SUCCESS = "booking/CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_FAILURE = "booking/CREATE_BOOKING_FAILURE";
export const SUBMIT_PROPOSAL_INIT = "booking/SUBMIT_PROPOSAL_INIT";
export const SUBMIT_PROPOSAL_SUCCESS = "booking/SUBMIT_PROPOSAL_SUCCESS";
export const SUBMIT_PROPOSAL_FAILURE = "booking/SUBMIT_PROPOSAL_FAILURE";
export const REVISE_BOOKING_INIT = "booking/REVISE_BOOKING_INIT";
export const REVISE_BOOKING_SUCCESS = "booking/REVISE_BOOKING_SUCCESS";
export const REVISE_BOOKING_FAILURE = "booking/REVISE_BOOKING_FAILURE";
export const CONFIRM_BOOKING_INIT = "booking/CONFIRM_BOOKING_INIT";
export const CONFIRM_BOOKING_SUCCESS = "booking/CONFIRM_BOOKING_SUCCESS";
export const CONFIRM_BOOKING_FAILURE = "booking/CONFIRM_BOOKING_FAILURE";
export const GET_PAYMENTS_INIT = "booking/GET_PAYMENTS_INIT";
export const GET_PAYMENTS_SUCCESS = "booking/GET_PAYMENTS_SUCCESS";
export const GET_PAYMENTS_FAILURE = "booking/GET_PAYMENTS_FAILURE";
export const DELETE_PAYMENT = "booking/DELETE_PAYMENT";
export const MAKE_PAYMENT_INIT = "booking/MAKE_PAYMENT_INIT";
export const MAKE_PAYMENT_SUCCESS = "booking/MAKE_PAYMENT_SUCCESS";
export const MAKE_PAYMENT_FAILURE = "booking/MAKE_PAYMENT_FAILURE";
export const SET_EDITING_BOOKING = "booking/SET_EDITING_BOOKING";

export interface BookingState {
  editingBooking: boolean;
  editableBooking: (Inquiry & Event) | null;
  bookings: { [bookingId: string]: Booking };
  revisions: {
    [bookingId: string]: {
      [revisionId: string]: Revision;
    };
  };
  payments: { [paymentId: string]: Payment };
  isGettingBookings: boolean;
  successGettingBookings: boolean;
  errorGettingBookings: Error | null;
  isCreatingBooking: boolean;
  successCreatingBooking: boolean;
  errorCreatingBooking: Error | null;
  isSubmittingProposal: boolean;
  successSubmittingProposal: boolean;
  errorSubmittingProposal: Error | null;
  isRevisingBooking: boolean;
  successRevisingBooking: boolean;
  errorRevisingBooking: Error | null;
  isConfirmingBooking: boolean;
  successConfirmingBooking: boolean;
  errorConfirmingBooking: Error | null;
  isGettingPayments: boolean;
  successGettingPayments: boolean;
  errorGettingPayments: Error | null;
  isMakingPayment: boolean;
  successMakingPayment: boolean;
  errorMakingPayment: Error | null;
}

interface ResetBookingAction {
  type: typeof RESET_BOOKING;
}

interface SetEditingBookingAction {
  type: typeof SET_EDITING_BOOKING;
  editing: boolean;
}

interface GetBookingsInitAction {
  type: typeof GET_BOOKINGS_INIT;
}

interface LoadEditableBookingAction {
  type: typeof LOAD_EDITABLE_BOOKING;
  booking: (Inquiry & Event) | null;
}

interface EditBookingAction {
  type: typeof EDIT_BOOKING;
  changes: Partial<Inquiry & Event>;
}

interface GetBookingsSuccessAction {
  type: typeof GET_BOOKINGS_SUCCESS;
  bookings: {
    [bookingId: string]: Booking;
  };
}

interface GetBookingRevisionsSuccessAction {
  type: typeof GET_BOOKING_REVISIONS_SUCCESS;
  bookingId: string;
  revisions: {
    [revisionId: string]: Revision;
  };
}

interface GetBookingsFailureAction {
  type: typeof GET_BOOKINGS_FAILURE;
  error: Error;
}

interface DeleteBookingAction {
  type: typeof DELETE_BOOKING;
  bookingId: string;
}

interface DeleteRevisionAction {
  type: typeof DELETE_REVISION;
  bookingId: string;
  revisionId: string;
}

interface GetBookingsFailureAction {
  type: typeof GET_BOOKINGS_FAILURE;
  error: Error;
}

interface CreateBookingInitAction {
  type: typeof CREATE_BOOKING_INIT;
}

interface CreateBookingSuccessAction {
  type: typeof CREATE_BOOKING_SUCCESS;
}

interface CreateBookingFailureAction {
  type: typeof CREATE_BOOKING_FAILURE;
  error: Error;
}

interface SubmitProposalInitAction {
  type: typeof SUBMIT_PROPOSAL_INIT;
}

interface SubmitProposalSuccessAction {
  type: typeof SUBMIT_PROPOSAL_SUCCESS;
}

interface SubmitProposalFailureAction {
  type: typeof SUBMIT_PROPOSAL_FAILURE;
  error: Error;
}

interface ReviseBookingInitAction {
  type: typeof REVISE_BOOKING_INIT;
}

interface ReviseBookingSuccessAction {
  type: typeof REVISE_BOOKING_SUCCESS;
}

interface ReviseBookingFailureAction {
  type: typeof REVISE_BOOKING_FAILURE;
  error: Error;
}

interface ConfirmBookingInitAction {
  type: typeof CONFIRM_BOOKING_INIT;
}

interface ConfirmBookingSuccessAction {
  type: typeof CONFIRM_BOOKING_SUCCESS;
  bookingId: string;
}

interface ConfirmBookingFailureAction {
  type: typeof CONFIRM_BOOKING_FAILURE;
  error: Error;
}

interface MakePaymentInitAction {
  type: typeof MAKE_PAYMENT_INIT;
}

interface MakePaymentSuccessAction {
  type: typeof MAKE_PAYMENT_SUCCESS;
}

interface MakePaymentFailureAction {
  type: typeof MAKE_PAYMENT_FAILURE;
  error: Error;
}

interface GetPaymentsInitAction {
  type: typeof GET_PAYMENTS_INIT;
}

interface GetPaymentsSuccessAction {
  type: typeof GET_PAYMENTS_SUCCESS;
  payments: {
    [paymentId: string]: Payment;
  };
}

interface GetPaymentsFailureAction {
  type: typeof GET_PAYMENTS_FAILURE;
  error: Error;
}

interface DeletePaymentAction {
  type: typeof DELETE_PAYMENT;
  paymentId: string;
}

export type BookingActionTypes =
  | ResetBookingAction
  | SetEditingBookingAction
  | GetBookingsInitAction
  | GetBookingsSuccessAction
  | GetBookingRevisionsSuccessAction
  | GetBookingsFailureAction
  | DeleteBookingAction
  | DeleteRevisionAction
  | CreateBookingInitAction
  | CreateBookingSuccessAction
  | CreateBookingFailureAction
  | ReviseBookingInitAction
  | ReviseBookingSuccessAction
  | ReviseBookingFailureAction
  | SubmitProposalInitAction
  | SubmitProposalSuccessAction
  | SubmitProposalFailureAction
  | ConfirmBookingInitAction
  | ConfirmBookingSuccessAction
  | ConfirmBookingFailureAction
  | GetPaymentsInitAction
  | GetPaymentsSuccessAction
  | GetPaymentsFailureAction
  | DeletePaymentAction
  | MakePaymentInitAction
  | MakePaymentSuccessAction
  | MakePaymentFailureAction
  | LoadEditableBookingAction
  | EditBookingAction;
